$(document).ready(function () {
  $(".close-menu").on("click", function () {
    $(".mobile-navigation").removeClass("expand");
  });
  $(".menu-btn").on("click", function () {
    $(".mobile-navigation").addClass("expand");
  });
  $(".menu-item-has-children > i").on("click", function () {
    $(this).next("ul.sub-menu").slideToggle();
  });
});
